import { NavLeftLayout } from 'vopay';
import React from 'react';
import { useHistory } from 'react-router-dom';
import NavigationMenu from '../NavigationMenu/NavigationMenu';
import { usePartnerLogin } from '@/providers/PartnerLogin.provider';
import { useNavMenu } from '@/providers/NavMenu.provider';
import useOpenModule from '@/hooks/useOpenModule';

type NavLeftContainerType = {
  logo?: string;
  smallLogo?: string;
  expandMenu?: boolean;
};

const NavLeftContainer: React.FC<NavLeftContainerType> = ({ logo, smallLogo, expandMenu }) => {
  const { logout } = usePartnerLogin();
  const history = useHistory();
  const { onNavClick } = useNavMenu();
  const [, setOpenModule] = useOpenModule();

  return (
    <NavLeftLayout
      logo={logo}
      smallLogo={smallLogo}
      onLogoClick={() => {
        onNavClick('dashboard');
        setOpenModule('dashboard');
        history.push('/dashboard');
      }}
      navMenu={<NavigationMenu expandMenu={expandMenu} />}
      expandMenu={expandMenu}
      onLogoutClick={logout}
    />
  );
};

export default NavLeftContainer;
